import 'babel-polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

svg4everybody();

window.$ = $;
window.jQuery = $;

import 'parsleyjs';

import 'gsap/umd/TweenMax';
import 'gsap/umd/ScrollToPlugin';

import customEase from './vendor/CustomEase';
window.customEase = customEase;

// import Player from '@vimeo/player';
// window.Player = Player;
